import { Button, Typography } from 'antd'
import React, { FC } from 'react'

import { useQuery } from '@apollo/client'

import { ACCOUNT_TEAM_MEMBERS } from 'shared/gql'
import { CollaboratorSummary } from 'shared/molecules/CollaboratorSummary'
import { TeamInviteButton } from 'dash/shared/molecules/TeamInviteButton'
import { PlusOutlined, RightOutlined } from '@ant-design/icons'

type TeamPanelProps = {
  accountId: string
}

export const TeamPanel: FC<TeamPanelProps> = ({ accountId }) => {
  const variables = {
    filter: {
      accountId: accountId,
      status: 'active',
    },
    page: 0,
    perPage: 3,
  }

  const { data, loading, error } = useQuery(ACCOUNT_TEAM_MEMBERS, {
    // fetchPolicy: 'no-cache', // ensure refetch on componentDidMount
    variables,
  })

  if (error) {
    console.log(error)
    return null
  }

  const users = loading ? [] : data.items.map((item) => item.user)
  const total = loading ? null : data.total.count

  return (
    <CollaboratorSummary
      style={{
        marginLeft: '1rem',
      }}
      button={
        <TeamInviteButton
          accountId={accountId}
          button={
            <Typography.Link>
              <PlusOutlined
                style={{
                  marginRight: '.4em',
                }}
              />
              Invite
            </Typography.Link>
          }
        />
      }
      count={total}
      users={users}
    />
  )
}
